import React from 'react';
import './orcid.scss';
import { Controls, validators } from 'shared/helper/form';
var Text = Controls.Text;
var createRegularExpressionValidator = validators.createRegularExpressionValidator;
var _validOrcid = createRegularExpressionValidator(/^(https:\/\/orcid.org\/)?\d{4}[-| ]?\d{4}[-| ]?\d{4}[-| ]?\d{3}[0-9X]$/i);
var Orcid = function Orcid(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/React.createElement("div", {
    className: "orcid"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "ORCID",
    messages: {
      validOrcid: 'orcid-error-message'
    },
    name: "orcid",
    placeholder: "0000-0000-0000-0000",
    styles: styles,
    validators: {
      validOrcid: function validOrcid(value) {
        return !value || _validOrcid(value);
      }
    }
  }));
};
export default Orcid;